import once from 'lodash/once'
import isEqual from 'lodash/isEqual'
import { chunks } from 'app/views/events'

const SUBSCRIPTION_TIMEOUT = 2000

export const scrollBehavior = (to, from, savedPosition) => {
  if (!savedPosition) return null

  return new Promise((resolve) => {
    const r = once(resolve)

    if (to.name === from.name) {
      r(false)
    } else {
      chunks.subscribeOnceLoaded(() => {
        r(savedPosition)
      })

      setTimeout(r, SUBSCRIPTION_TIMEOUT)
    }
  })
}

/**
 * This is based off the example from Algolia.
 *
 * https://www.algolia.com/doc/guides/building-search-ui/going-further/routing-urls/vue/#combining-with-vue-router
 *
 * We've removed the window.addEventListener('popstate', ...) handling because
 * it didn't seem to provide any value and in fact duplicated and messed with
 * some of the back/forward button interactions. So it's been removed but there
 * is a part of me that wonders why it was there in the first place.
 */
export const glueWithVue = (vm) => {
  return {
    read() {
      return vm.$router.currentRoute.query
    },

    write(routeState) {
      if (!isEqual(routeState, vm.$router.currentRoute.query)) {
        vm.$router.push({
          query: routeState
        })
      }
    },

    createURL(routeState) {
      return vm.$router.resolve({
        query: routeState
      }).href
    },

    onUpdate(cb) {
      if (typeof window === 'undefined') return

      this._removeAfterEach = vm.$router.afterEach(() => {
        cb(this.read())
      })
    },

    dispose() {
      if (typeof window === 'undefined') {
        return
      }

      if (this._removeAfterEach) {
        this._removeAfterEach()
      }
    }
  }
}
